export default {
	search(params, cb, ecb) {
		this.http
			.get('/item/search', { params })
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	status(id, to, cb, ecb) {
		this.http
			.get(`/item/status/${id}/${to}`)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getItemSKUAtts(id, cb) {
		this.http.get('/item/skuAtts2/' + id, {}).then((response) => {
			cb(response)
		})
	},
	getItemStock(id, sku, cb, ecb) {
		this.http
			.get('/item/stockOf/' + id + '/' + JSON.stringify(sku), {})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getItemStocks(id, cb) {
		this.http.get('/item/stocksOf/' + id, {}).then((res) => {
			cb(res)
		})
	},
	getByCategories(cats, cb) {
		this.http
			.get('/item/getItemsByCategories/' + cats.join(','), {})
			.then((r) => cb && cb(r))
	},
	getByCategory(catid, params, cb) {
		this.http
			.post('/item/getItemsByCategory/' + catid, params)
			.then((response) => {
				cb(response)
			})
	},
	getByTag(tag, params, cb) {
		this.http
			.post('/item/getItemsByTag/' + tag, params)
			.then((response) => {
				cb(response)
			})
	},
	getAll(catid, params, cb) {
		this.http
			.post('/item/getItemsByCategory/' + catid, params)
			.then((response) => {
				cb(response)
			})
	},
	getAllByTag(tag, params, cb) {
		this.http
			.post('/item/getItemsByTag/' + tag, params)
			.then((response) => {
				cb(response)
			})
	},
	getById(id, cb) {
		this.http.get(`/item/getById/${id}`, {}).then((response) => {
			cb(response)
		})
	},
	update(form, cb) {
		this.http.post('/item/update/', form).then((response) => {
			cb(response)
		})
	},
	getSKUs(itemid, cb) {
		this.http.get(`/item/getSKUs/${itemid}`, {}).then((response) => {
			cb(response)
		})
	},
	getSKUsById(ids, cb) {
		this.http.get('/item/getSKUsById/' + ids, {}).then((response) => {
			cb(response)
		})
	},
	getSKUsByCategory(catid, cb) {
		this.http.get(`/item/getSKUsByCategory/${catid}`).then((skus) => {
			cb(skus)
		})
	},
	getBOMBySKU(skuid, cb, ecb) {
		this.http
			.get(`/item/getBOMBySKU/${skuid}`, {})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	}
}
